<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><router-link to="/"><span class="icon-chevron-left"></span></router-link></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <div class="image-box">
        <img src='/static/img/services/car1.jpg'>
    </div>

    <div class="pricing">
      <div class="price-title">收费标准</div>
      <div class="price-sub">悉尼 - Kingsford Smith Airport</div>
      
      <table class="pure-table pure-table-bordered">
          <thead>
              <tr>
                  <th>目的地</th>
                  <th>正常时间价格 (6:00-20:00)</th>
                  <th>特殊时间价格 (20:00-6:00)</th>
              </tr>
          </thead>
          <tbody>
            <tr v-for="item in pricetable" :key="item.suburb">
            <td>{{ item.suburb }}</td>
            <td>{{ item.price1 }}</td>
            <td>{{ item.price2 }}</td>
          </tr>
          <tr>
            <td colspan=3>如地点不在收费列表中，请联系客服获取价格</td>
          </tr>
          </tbody>
      </table>
      <div class="price-note">* 接机等待时间备注<br>飞机实际落地时间60分钟内免费等待，超过后每半小时收取＄20，不足半小时按半小时计算</div>
    </div>
    <div class="btn-box-fix">
      <div class="slogan">具体费用以及服务详情，客服将为您解答</div>
      <div class="btn-container">
        <a href="javascript:void(0)" class="btn active" @click="$router.push('/service/form/car?back=1')"> 下单接送机服务</a>
        <!-- <a href="tel:0477747777" class="btn active"  v-if="workingHours<9 || workingHours>21"> 下单接送机服务</a>
        <a href="javascript:void(0)" id="chatnow" class="btn active"  v-if="workingHours>=9 && workingHours<=21"> 下单接送机服务</a> -->
      </div>
    </div>
    <img :src="pixelURL('jiesongji','baojia')" class="hide">
  </div>
</template>

<script>
import 'purecss/build/tables-min.css';
export default {
  name: 'car',
  data () {
    return {
      order:{},
      pricetable:[
        {
        "suburb": "Ashfield",
        "price1": "$75",
        "price2": "$95"
        },
        {
        "suburb": "Auburn",
        "price1": "$100",
        "price2": "$120"
        },
        {
        "suburb": "Bankstown",
        "price1": "$80",
        "price2": "$100"
        },
        {
        "suburb": "Blacktown",
        "price1": "$150",
        "price2": "$170"
        },
        {
        "suburb": "Box Hill",
        "price1": "$180",
        "price2": "$200"
        },
        {
        "suburb": "Burwood",
        "price1": "$80",
        "price2": "$100"
        },
        {
        "suburb": "Campsie",
        "price1": "$75",
        "price2": "$95"
        },
        {
        "suburb": "Carlingford",
        "price1": "$120",
        "price2": "$140"
        },
        {
        "suburb": "Chatswood",
        "price1": "$90",
        "price2": "$110"
        },
        {
        "suburb": "Eastwood",
        "price1": "$110",
        "price2": "$130"
        },
        {
        "suburb": "Epping",
        "price1": "$110",
        "price2": "$130"
        },
        {
        "suburb": "Haymarket",
        "price1": "$80",
        "price2": "$100"
        },
        {
        "suburb": "Hurstville",
        "price1": "$75",
        "price2": "$95"
        },
        {
        "suburb": "Kellyville",
        "price1": "$150",
        "price2": "$170"
        },
        {
        "suburb": "Kingsford",
        "price1": "$75",
        "price2": "$95"
        },
        {
        "suburb": "Liverpool",
        "price1": "$125",
        "price2": "$145"
        },
        {
        "suburb": "Manly",
        "price1": "$130",
        "price2": "$150"
        },
        {
        "suburb": "Marsfield",
        "price1": "$100",
        "price2": "$120"
        },
        {
        "suburb": "Meadowbank",
        "price1": "$95",
        "price2": "$115"
        },
        {
        "suburb": "Mosman",
        "price1": "$100",
        "price2": "$120"
        },
        {
        "suburb": "Parramatta",
        "price1": "$120",
        "price2": "$140"
        },
        {
        "suburb": "Pymble",
        "price1": "$110",
        "price2": "$130"
        },
        {
        "suburb": "Rhodes",
        "price1": "$95",
        "price2": "$115"
        },
        {
        "suburb": "Ryde",
        "price1": "$95",
        "price2": "$115"
        },
        {
        "suburb": "Surry Hills",
        "price1": "$80",
        "price2": "$100"
        },
        {
        "suburb": "Sydney",
        "price1": "$80",
        "price2": "$100"
        },
        {
        "suburb": "Sydney Olympic Park",
        "price1": "$95",
        "price2": "$115"
        },
        {
        "suburb": "Ultimo",
        "price1": "$80",
        "price2": "$100"
        },
        {
        "suburb": "Wahroonga",
        "price1": "$125",
        "price2": "$145"
        },
        {
        "suburb": "Waterloo",
        "price1": "$75",
        "price2": "$95"
        },
        {
        "suburb": "Wentworth Point",
        "price1": "$95",
        "price2": "$115"
        },
        {
        "suburb": "Zetland",
        "price1": "$75",
        "price2": "$95"
        }
        ]
    }
  },
  methods: {

  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    }
  },
  components: {
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:80px;
}

.title{
  font-size:1.4em;
}
.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:2vh;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.image-box{
  img{
    width:100%;
  }
  font-size:0;
}
.btn{
  margin-top:20px;
}
.text{
  text-align:center;
  font-size:1.2em;
  color:#888;
}

.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}

.btn-box-fix .btn.active{
  margin-left:0;
  margin-top:0;
}
.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}
.pricing{
  .price-title{
    font-size:2em;
    color:#555;
    text-align:center;
    margin:30px 0 0 10px;
  }
  .price-sub{
    color:#555;
    text-align:center;
    margin-bottom:20px;
  }
  .price-note{
    color:#555;
    text-align:center;
    margin:16px auto 40px auto;
    font-size:0.9em;
    width:80%;

  }
  .pure-table{
    border: 1px solid #e3e3e3;
    th,td{
      text-align: center;
      vertical-align: middle;
    }
    margin: 0 auto;
    width: 90%;
    font-size:0.84em;
  }
  .pure-table td, .pure-table th{
      border-left: 1px solid #e3e3e3;
  }
  .pure-table-bordered td {
    border-bottom: 1px solid #e3e3e3;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/service/car.vue